<template>
  <div class="container">
    <CHeader />
    <slot />
  </div>
</template>

<script setup lang="ts">
import CHeader from "@/layout/Dashboard/components/CHeader.vue";
</script>

<style scoped></style>
